import React from "react";
import { CreatePlans } from "../../../containers";

const CreatePlan = (props) => {
  return <CreatePlans {...props} />;
};

export default CreatePlan;
